module.exports = __webpack_public_path__ + "static/media/Bath4.90d0c24f.jpg";